import { WellGuideActions } from '../actions/WellGuideActions';
import { unauthorizedResponse } from '../components/WellGuide/constants';

const initialState = {
    gettingRecommendations: false,
    recommendationsRetrieved: false,
    recommendations: unauthorizedResponse,
};

export const wellGuideReducer = (state = initialState, action) => {
    switch (action.type) {
        case WellGuideActions.FETCHING_WELL_GUIDE_DATA: {
            return {
                ...state,
                gettingRecommendations: true,
                recommendationsRetrieved: false,
            };
        }

        case WellGuideActions.FETCHING_WELL_GUIDE_SUCCESS: {
            return {
                ...state,
                recommendations: action.responseBody.recommendations,
                gettingRecommendations: false,
                recommendationsRetrieved: true,
            };
        }

        case WellGuideActions.FETCHING_WELL_GUIDE_FAILURE: {
            return {
                ...state,
                gettingRecommendations: false,
                recommendationsRetrieved: true,
            };
        }

        default: {
            return {
                ...state,
            };
        }
    }
};
